import { Observable } from "rxjs";
import NetworkService from "../network/networkService";
import { helperFunctions } from "../helper/helper";
import { AgTechQueryParam } from "../enums/AgTechQueryParams.enum";
import { URLConfig } from "../network/urlStore";
import { INotesAllResponse } from "../models/INotes.model";

export const getNotes = (
  queryParams?: Array<{
    key: AgTechQueryParam;
    value: string[];
  }>
): Observable<INotesAllResponse> => {
  let url = `${URLConfig.getNotesURL()}`;
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        const response = res as INotesAllResponse;
        subscriber.next(response);
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching notes data", error);
      }
    );
  });
};

export const getNotesNextPage = (
  nextPageURI: string
): Observable<INotesAllResponse> => {
  const url = URLConfig.getNotesNextPageURL(nextPageURI);
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        const response = res as INotesAllResponse;
        subscriber.next(response);
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching notes data", error);
      }
    );
  });
};

export const getNotesCount = (
  queryParams?: Array<{
    key: AgTechQueryParam;
    value: string[];
  }>
): Observable<number> => {
  let url = `${URLConfig.getNotesURL()}`;
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.head(url)
      .then((res: any) => {
        subscriber.next(res?.contentLength ?? 0);
        subscriber.complete();
      })
      .catch((error: Error) => {
        subscriber.error(error);
        subscriber.next(0);
        console.log("Error while fetching notes data:", error);
      });
  });
};

export const createNotes = (
  resourceType: string,
  resourceId: string,
  requestPayload: any
): Observable<INotesAllResponse> => {
  const url = `${URLConfig.getNotesURL()}/${resourceType}/${resourceId}`;
  return new Observable((subscriber) => {
    NetworkService.post(url, requestPayload).then(
      (response: unknown) => {
        const res = response as INotesAllResponse;
        subscriber.next(res);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while creating a notes", error);
      }
    );
  });
};

export const updateNotes = (
  notesPayload: any,
  noteId: number
): Observable<INotesAllResponse> => {
  const url = `${URLConfig.getNotesURL()}/${noteId}`;
  return new Observable((subscriber) => {
    NetworkService.patch(url, notesPayload).then(
      (res) => {
        const response = res as unknown as INotesAllResponse;
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while updating notes", error);
      }
    );
  });
};

export const deleteNotes = (
  noteId: number
): Observable<INotesAllResponse> => {
  const url = `${URLConfig.getNotesURL()}/${noteId}`;
  return new Observable((subscriber) => {
    NetworkService.delete(url).then(
      (res) => {
        const response = res as unknown as INotesAllResponse;
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while updating notes", error);
      }
    );
  });
};
